import { render, staticRenderFns } from "./CreateHeader.vue?vue&type=template&id=672e0bcf&"
import script from "./CreateHeader.vue?vue&type=script&lang=js&"
export * from "./CreateHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports